import axios from 'axios'
import { useAuthStore } from '@/stores/authStore'

const API_URL = import.meta.env.VITE_API_URL

export const apiClient = axios.create({
  baseURL: API_URL ? `${API_URL}/api` : '/api',
  headers: {
    'Content-Type': 'application/json',
  },
})

// Request interceptor to add auth token
apiClient.interceptors.request.use(
  (config) => {
    const token = useAuthStore.getState().token
    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    }
    return config
  },
  (error) => {
    return Promise.reject(error)
  }
)

// Response interceptor to handle auth errors.
//
// A 401 only means "your session expired" when it comes back from a *protected*
// request made while logged in. A 401 from the auth flow itself (e.g. a wrong
// password on /auth/login) must be left for the calling page to display —
// otherwise we'd hard-redirect away from the login page and lose the error.
apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error.response?.status
    const requestUrl: string = error.config?.url || ''
    const isAuthEndpoint = requestUrl.includes('/auth/')
    const wasAuthenticated = !!useAuthStore.getState().token

    if (status === 401 && wasAuthenticated && !isAuthEndpoint) {
      const orgSlug = useAuthStore.getState().org_slug
      useAuthStore.getState().logout()
      // Send an expired session back to its org login page, never the landing page.
      window.location.href = orgSlug ? `/${orgSlug}/login` : '/'
    }
    return Promise.reject(error)
  }
)
